module.exports = __webpack_public_path__ + "static/media/sound3.bbdd3cd8.mp3";